import React, { useEffect, useRef } from 'react'

import Breadcrumb from 'react-bootstrap/Breadcrumb';
import './brandguidline.scss'
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
gsap.registerPlugin(ScrollTrigger);

const Brandguidline = () => {
    const textRef = useRef(null);

    useEffect(() => {
        const tl = gsap.timeline();

        gsap.set(textRef.current, {
            clipPath: "inset(0% 100% 0% 0%)",
            opacity: 1,
        });

        tl.to(textRef.current, {
            clipPath: "inset(0% 0% 0% 0%)",
            duration: 1,
            ease: "power2.out",
        });
    }, []);


    useEffect(() => {
        gsap.from(".breadvrumbcnt, .breadvrumbcntactive", {
            opacity: 0,
            y: 10,
            duration: 0.6,
            stagger: 0.2,
            ease: "power2.out",
        });
    }, []);

    const breadcrumbSchema = {
        "@context": "https://schema.org/",
        "@type": "BreadcrumbList",
        "itemListElement": [
            {
                "@type": "ListItem",
                "position": 1,
                "name": "Home",
                "item": "https://tomi.com/"
            },
            {
                "@type": "ListItem",
                "position": 2,
                "name": "Brand Guidelines", // ✅ Level 2 in JSON
                "item": "https://tomi.com/brandguidelines"
            }
        ]
    };

    useEffect(() => {
        const script = document.createElement("script");
        script.type = "application/ld+json";
        script.innerHTML = JSON.stringify(breadcrumbSchema);
        document.head.appendChild(script);

        return () => {
            document.head.removeChild(script);
        };
    }, []);

    useEffect(() => {
            document.title = "Brand Assets - Explore tomi's brand style and assets";
    
            const metaDescription = document.querySelector("meta[name='description']");
            if (metaDescription) {
                metaDescription.setAttribute(
                    "content",
                    "Get tomi Brand Assets: Join Our Vibrant Online Communities. Stay updated, ask questions, and engage with fellow tomi users! "
                );
            } else {
                const newMeta = document.createElement("meta");
                newMeta.name = "description";
                newMeta.setAttribute(
                    "content",
                    "Get tomi Brand Assets: Join Our Vibrant Online Communities. Stay updated, ask questions, and engage with fellow tomi users! "
                );
                document.head.appendChild(newMeta);
            }
        }, []);


    return (
        <section className='brandguidlineprnt'>
            <img src="\assets\Brandguidline\brandguidlinebg.png" alt="img" className='img-fluid brandguidlinebg' />
            <div className="custom-container">

                <div className="brandguidlinecnthero">

                    <nav aria-label="breadcrumb">
                        <Breadcrumb className="breadcrumbprnt">
                            <Breadcrumb.Item className="breadvrumbcnt" href="/">
                                Home
                            </Breadcrumb.Item>
                            <Breadcrumb.Item className="breadvrumbcnt">
                                Company
                            </Breadcrumb.Item>
                            <Breadcrumb.Item
                                className="breadvrumbcntactive"
                            >
                                Brand Guidelines
                            </Breadcrumb.Item>
                        </Breadcrumb>
                    </nav>
                    <h1 ref={textRef}>Brand Guidelines</h1>
                </div>

            </div>

        </section>
    )
}

export default Brandguidline